import { LOCALE_ID, NgModule, inject, provideAppInitializer } from '@angular/core';
import { AdminLayoutModule } from './admin-layout/admin-layout.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppConfigService } from './core/services/app-config.service';
import localeDe from '@angular/common/locales/de';
import '@progress/kendo-angular-intl/locales/de/all';
import { CommonModule, registerLocaleData } from '@angular/common';
import { AuthModule } from './auth/auth.module';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ClientComponent } from './pages/client/client.component';
import { CreateEditClientComponent } from './pages/client/create-edit-client/create-edit-client.component';
import { HTTP_INTERCEPTORS, provideHttpClient, withXsrfConfiguration } from '@angular/common/http';
import { AuthInterceptorService } from './core/interceptors/auth-interceptor.service';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { HttpErrorInterceptorService } from './core/interceptors/http-error-interceptor.service';
import { ICON_SETTINGS } from '@progress/kendo-angular-icons';
import { ClientDialogComponent } from './pages/client/dialogs/client-dialog/client-dialog.component';
import { InvitationRegistrationComponent } from './public/invitation-registration/invitation-registration.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import 'hammerjs';
import { ProjectModule } from './pages/project/project.module';
import { SettingsModule } from './pages/settings/settings.module';
import { TeamModule } from './pages/team/team.module';
import { UserModule } from './pages/user/user.module';
import { ReportsModule } from './pages/reports/reports.module';
import { FinanceModule } from './pages/finances/finance.module';
import { firstValueFrom } from 'rxjs';
import { ClientListComponent } from './pages/client/client-list/client-list.component';
import { TimeTrackingModule } from './pages/time-tracking/time-tracking.module';
import { MyTodosModule } from './pages/my-todos/my-todos.module';

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    ClientComponent,
    CreateEditClientComponent,
    ClientListComponent,
    ClientDialogComponent,
    InvitationRegistrationComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    AppRoutingModule,
    AdminLayoutModule,
    CoreModule,
    SharedModule,
    AuthModule,
    TimeTrackingModule,
    ProjectModule,
    UserModule,
    TeamModule,
    FinanceModule,
    ReportsModule,
    MyTodosModule,
    SettingsModule,
    CommonModule,
    InputsModule,
  ],
  providers: [
    provideAppInitializer(() => {
      const appConfigService = inject(AppConfigService);
      return firstValueFrom(appConfigService.loadAppConfig());
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptorService,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'de-DE' },
    { provide: ICON_SETTINGS, useValue: { type: 'svg' } },
    provideHttpClient(
      withXsrfConfiguration({
        cookieName: 'csrftoken',
        headerName: 'csrftoken',
      }),
    ),
  ],
})
export class AppModule {}
